import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    background: theme.palette.custom.background.area,
    boxShadow: theme.shadows[25],
    margin: theme.spacing(3),
    maxWidth: '100%',
    overflow: 'hidden',

    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(3, 0),
    },

    '& .schedule': {
      '&-header': {
        display: 'flex',
        alignItems: 'center',
        height: theme.spacing(21 / 2),
        minHeight: theme.spacing(21 / 2),
        padding: theme.spacing(0, 3),
        color: theme.palette.text.secondary,
        borderBottom: `solid 1px ${theme.palette.divider}`,

        '&-title': {
          flexGrow: 1,
        },
      },
      '&-body': {
        overflow: 'auto',

        '&-fixed': {
          position: 'sticky',
          top: 0,
          zIndex: 5,
        },
        '&-scrollable': {
          display: 'flex',
          justifyContent: 'space-between',
        },
        '&-content-wrapper': {
          width: '100%',
        },
      },
    },
  },
}));

export default styles;
